var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"value":_vm.select,"options":_vm.options},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }